export default __webpack_public_path__ + "b44450f92078e824ccbae40b73284947.png";